import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { 
        feedbackSuccess: {
          title: 'Feedback submitted',
          successLine1: 'Your feedback (ID: {{id}}) has been received successfully.',
          successLine2: 'If you wish, you can add another feedback item.',
          closeButton: 'Close',
          addAnotherButton: 'Add Another'
        },
        feedbackModalUI: {
          title: "Add feedback",
          tabs: {
            bug: "Report Bug",
            task: "Leave Comment"
          },
          form: {
            titleLabel: "Title",
            priorityLabel: "Priority (1-5)",
            severityLabel: "Severity",
            stepsLabel: "Steps to reproduce",
            descriptionLabel: "Description"
          },
          buttons: {
            close: "Close",
            submit: "Submit Feedback"
          }
        }
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
